import { directiveSettings } from '../../utils/parse';
import { bindEvents } from '../../utils/window';
/**
 * @module directives/action/scroller
 */

 const docEl = document.documentElement;
 
 let breakable = true;
 let breakTimeout = null;
 let bound = false;

/**
 * Scrolls to a point on the page when an element is clicked.
 * Scrolls to top: <button data-sw-scroller="top">Top</button>
 * Scrolls to bottom: <button data-sw-scroller="bottom">Bottom</button>
 * Scrolls to element by ID: <button data-sw-scroller="#element">Element</button>
 */
export default function scrollerDirective() {
  document.querySelectorAll('[data-sw-scroller]').forEach(element => {
    const data = element.getAttribute('data-sw-scroller'),
    settings = directiveSettings(data, {
      to: 'top',
      selector: null,
      speed: 500,
    }, 'to');

    element.addEventListener('click', event => {
      event.preventDefault();
      clearInterval(breakTimeout);
      
      breakable = false;
      breakTimeout = setTimeout(_ => breakable = true, 100);

      let top = 0;
      switch (settings.to) {
        case 'top':
          top = 0;
          break;
        case 'bottom':
          top = docEl.scrollHeight - docEl.clientHeight;
          break;
        case 'element':
          const headerHeight = document.querySelector('header').offsetHeight;
          top = document.querySelector(settings.selector).getBoundingClientRect().top + window.scrollY - window.outerHeight + window.innerHeight - headerHeight * 1.5;
          break;
        default:
          top = document.querySelector(settings.to).offsetTop - 120;
      }
      
      window.scrollTo({
        top: Math.min(top, docEl.scrollHeight - docEl.clientHeight),
        behavior: 'smooth'
      });
    });
  });

  if (!bound) {
    bound = true;
    bindEvents(document.body, 'scroll mousedown DOMMouseScroll mousewheel keyup touchstart', event => {
      if (breakable) {
        switch (event.type) {
          case 'mousedown':
          case 'mousewheel':
          case 'touchstart': document.body.scroll({ top: docEl.scrollTop }); break;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/scroller.js